import React,{useState,useEffect} from 'react'
import { BrowserRouter as Router,Route,
    Switch, Link,useNavigate } from 'react-router-dom'
import LoginComponent from "../Login/LoginComponent";
import HomeComponent from "../Home/HomeComponent";    
import './Navbar.css'


function Navbar() {
  

  const navigate = useNavigate();
  //const user_data = localStorage.getItem('user') || {};
  //var user_status = localStorage.getItem('isLoggedIn');
  let user_info = JSON.parse(localStorage.getItem('user'))
  const[login,setLogin] = useState(false);

  const logout = (e) =>{
        e.preventDefault()
        localStorage.clear()
        navigate('/')  
  }

  useEffect(() =>{
    
    //setLogin(status)
  },[])


  return (
      <nav className="navbar fixed-top navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
              <a className="navbar-brand mx-3" href="#">
                <img src="/images/playbd-logo.png" alt="logo" title="logo"/>
              </a>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  
                  <ul className="navbar-nav ms-auto mx-3">
                    {
                    
                    localStorage.getItem('user') ? 
                     user_info.isAdmin ?
                      (<>
                        <li className='nav-link'>
                            <span className='text-primary'>Hello - <b>{user_info.userName}</b></span> 
                        </li>
                        <li className="nav-item" >
                            <Link to='/user' className='nav-link' >
                                Home
                            </Link>
                        </li>
                        {/* <li clasName="nav-item">
                                <Link to='/bookings' className="nav-link">
                                    My Bookings
                                </Link>
                        </li>
                        <li clasName="nav-item" >
                            <Link to='/adminbook' className='nav-link' >
                                Manage Bookings
                            </Link>
                        </li>
                        <li clasName="nav-item" >
                            <Link to='/mpermbook' className='nav-link' >
                                Manage P-Bookings
                            </Link>
                        </li>
                        <li clasName="nav-item" >
                            <Link to='/addtrainer' className='nav-link' >
                                Trainers
                            </Link>
                        </li>
                        <li clasName="nav-item" >
                            <Link to='/addterm' className='nav-link' >
                                TermDates
                            </Link>
                        </li> */}
                        <li clasName="nav-item" >
                            <Link onClick={logout} className='nav-link' >
                                Logout
                            </Link>
                        </li>
                      </>) 
                      :
                      <> 
                            <li className='nav-item'>
                                <span className='nav-link text-primary'>Hello - <b>{user_info.userName}</b></span> 
                            </li>
                            <li className='nav-item'>
                              <Link to='/user' className='nav-link'>
                                    Home
                              </Link>
                              {/* <span className='text-primary'>Hello - <b>{user_info.firstName}</b></span>  */}
                            </li>
                            {/* <li clasName="nav-item">
                                <Link to='/bookings' className="nav-link">
                                    My Bookings
                                </Link>
                            </li>
                            <li clasName="nav-item" >
                                <Link to='/adminbook' className='nav-link' >
                                    Manage Bookings
                                </Link>
                            </li> */}
                            
                             <li clasName="nav-item" >
                                      {/* <a  href="#" className="nav-link" onclick={logout}>Logout</a> */}
                                      <Link onClick={logout} className='nav-link' >
                                          Logout
                                      </Link>
                                      {/* <button className='navlink logout-btn' onClick={logout}>Logout</button> */}

                            </li>
                      </>
                       :
                       <>
                                  <li className="nav-item">
                                      {/* <a className="nav-link active" aria-current="page" href="#">Home</a> */}
                                      <Link to='/' className='nav-link'>
                                          Home
                                      </Link>
                                  </li>
                                  <li className="nav-item">
                                      {/* <a className="nav-link" href="#">About</a> */}
                                      <Link to='/about' className="nav-link">
                                            About
                                      </Link>
                                  </li>
                                  <li className="nav-item">
                                      {/* <a className="nav-link" href="#">Services</a> */}
                                      <Link to='/services' className='nav-link'>
                                          Services
                                      </Link>
                                  </li>
                                  <li className="nav-item">
                                      {/* <a className="nav-link" href="#">Services</a> */}
                                      <Link to='/price' className='nav-link'>
                                          SquadTraining
                                      </Link>
                                  </li>
                                  <li className="nav-item">
                                      {/* <a className="nav-link" href="#">Trainers</a> */}
                                      <Link to='/coach' className='nav-link' >
                                          Coaches
                                      </Link>
                                  </li>
                                  <li className="nav-item">
                                      {/* <a className="nav-link" href="#">Trainers</a> */}
                                      <Link to='/gallery' className='nav-link' >
                                          Gallery
                                      </Link>
                                  </li>
                                  <li clasName="nav-item">
                                      <Link to='/bookings' className="nav-link">
                                          My Bookings
                                      </Link>
                                      {/* <a href="#" className='nav-link'>My Bookings</a>  */}
                                  </li>
                                  <li clasName="nav-item">
                                      <Link to='/contact' className="nav-link">
                                          Contact-Us
                                      </Link>
                                      {/* <a href="#" className='nav-link'>My Bookings</a>  */}
                                  </li>
                                  <li className="nav-item" >
                                      {/* <a  href="#" className="nav-link" onclick={logout}>Logout</a> */}
                                      <Link to='/login' className='nav-link' >
                                          Login
                                      </Link>
                                      {/* <button className='navlink logout-btn' onClick={logout}>Logout</button> */}

                                  </li>
                                 
                        </>       
                      }
                  </ul>
              </div>
          </div>
      </nav>
  )
}

export default Navbar